import { Box, Card, CardContent, Divider, FormControlLabel, FormGroup, Grid, List, ListItem, Switch, Typography, Stack, Tabs, Tab, Icon, IconButton, TextField, Button, Checkbox, Badge, CircularProgress, FormHelperText } from '@mui/material';
import CommonLayout from 'layouts/DashboardLayout';
import React, { useEffect, useRef, useState } from 'react';
import AngleRightIcon from 'common/customIcons/angle_right';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate, useParams } from 'react-router';
import MDButton from 'components/MDButton'
import MDInput from 'components/MDInput';
import { openSnackbar, uploadImage } from '../../../redux/slices/common';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { hempRoutePermission, stiloRoutePermission, HperdriveRoutePermission, HwRoutePermission } from 'sideMenus';
import { addRoleandPermission, getRoleandPermissionByID } from '../../../redux/slices/roleAndPermissions';
import { CreateroleFormValidation } from 'validations/roleAndPermissions';
import { getData } from 'utilities/common';
import Loader from 'common/Loader';
import { posRoutePermission } from 'sideMenus';

const uploadThumbnailImage = {
  borderRadius: '50%',
  width: '44px',
  height: '44px',
  objectFit: 'cover',
  boxShadow: '0 0 1px rgb(0 0 0 / 20%)'
};
const circularProgressIcon = {
  backgroundColor: '#fff',
  borderRadius: 10,
  p: .5,
  position: 'absolute'
};
export default function AddRoles() {
  const navigate = useNavigate();
  const { isUploading = false } = useSelector(state => state.common);
  const [errors, setErrors] = useState({});
  const uploadedFileField = useRef(null);
  const dispatch = useDispatch()
  const { isLoading: loading = false, roleDataByID, loading: getLoding = false } = useSelector(state => state.roleAndPermissions);
  const { roleId } = useParams();

  const [formData, setFormData] = useState({
    "role": {
      "roleName": "",
      "roleIcon": ""
    },
    "platforms": {
      "hyperwolf": false,
      "hemp": false,
      "stilo": false,
      "pos": false,
      "hyperdrive": false
    },
    "permissions": {
      hwPermissions: [], stiloPermissions: [], hempPermissions: [], posPermissions: [],
      hyperdrivePermissions: []
    }
  })
  const containerRef = useRef(null);

  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const onMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - containerRef.current.offsetLeft);
    setScrollLeft(containerRef.current.scrollLeft);
  };

  const onMouseLeave = () => {
    setIsDragging(false);
  };

  const onMouseUp = () => {
    setIsDragging(false);
  };

  const onMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - containerRef.current.offsetLeft;
    const walk = (x - startX) * 1; // Multiply for sensitivity
    containerRef.current.scrollLeft = scrollLeft - walk;
  };

  const iconImageUploader = async (e) => {
    uploadedFileField.current = 'userIcon';
    if (e.target.files.length) {
      const file = e.target.files[0];
      const body = new FormData();
      body.append('filePath', file);
      // res.fileUrl
      dispatch(uploadImage(body)).unwrap().then((res => {
        setErrors({ ...errors, roleIcon: '' })

        setFormData(prevFormData => ({
          ...prevFormData,
          role: {
            ...prevFormData.role,
            roleIcon: res.fileUrl
          }
        }));
      }));
    }
  };
  const user = getData('login-user-info')

  const parseUser = JSON.parse(user)

  const handleSubmit = (e) => {
    e.preventDefault();
    const { errors, isValid } = CreateroleFormValidation(formData);
    if (!isValid) {
      setErrors(errors);
      return;
    }
    setErrors({});
    // Create payload
    const payload = {
      role: formData?.role,
      platforms: formData?.platforms,
      permissions: {},
      "updatedDate": Date.now(),
      updatedBy: parseUser?.name
    };
    // Helper function to filter permissions arrays
    const filterPermissions = (permissionsArray) => {
      return permissionsArray
        .map(category => {
          // Filter permissions within each category
          const filteredPermissions = category?.permissions
            .filter(perm => perm.status === true);

          // Only include category if it has at least one active permission
          if (filteredPermissions.length > 0) {
            return {
              ...category,
              permissions: filteredPermissions
            };
          }
          return null;
        })
        .filter(category => category !== null); // Remove null categories
    };

    // Process each platform's permissions based on platform status
    if (formData.platforms.hyperwolf) {
      payload.permissions.hwPermissions = filterPermissions(formData.permissions.hwPermissions);
    }

    if (formData.platforms.hemp) {
      payload.permissions.hempPermissions = filterPermissions(formData.permissions.hempPermissions);
    }

    if (formData.platforms.stilo) {
      payload.permissions.stiloPermissions = filterPermissions(formData.permissions.stiloPermissions);
    }

    if (formData.platforms.hyperdrive) {
      payload.permissions.hyperdrivePermissions = filterPermissions(formData.permissions.hyperdrivePermissions);
    }
    if (formData.platforms.pos) {
      payload.permissions.posPermissions = filterPermissions(formData.permissions.posPermissions);
    }

    // Remove permissions object if empty
    if (Object.keys(payload.permissions).length === 0) {
      delete payload.permissions;
    }

    dispatch(addRoleandPermission({ payload, roleId })).unwrap().then((res) => {
      showResponseMessage(res?.message, 'success');
      navigate(-1);
    }).catch((err) => {
      showResponseMessage(err?.message, 'error');

    });
  }
  const showResponseMessage = (message, errortype) => {
    if (errortype === 'success') {
      dispatch(openSnackbar({ content: message, color: 'success', icon: 'check' }));
    }
    if (errortype === 'error') {
      dispatch(openSnackbar({ content: message, color: 'error', icon: 'warning' }));
    }
  };

  const getRolesData = () => {
    dispatch(getRoleandPermissionByID(roleId)).unwrap().then((res) => {
      const apiData = res

      const formattedData = {
        role: {
          roleName: apiData.role?.roleName || "",
          roleIcon: apiData.role?.roleIcon || ""
        },
        platforms: {
          hyperwolf: apiData.platforms?.hyperwolf || false,
          hemp: apiData.platforms?.hemp || false,
          stilo: apiData.platforms?.stilo || false,
          hyperdrive: apiData.platforms?.hyperdrive || false,
          pos: apiData.platforms?.pos || false

        },
        permissions: {
          hwPermissions: apiData.permissions?.hwPermissions || [],
          stiloPermissions: apiData.permissions?.stiloPermissions || [],
          hempPermissions: apiData.permissions?.hempPermissions || [],
          hyperdrivePermissions: apiData.permissions?.hyperdrivePermissions || [],
          posPermissions: apiData.permissions?.posPermissions || []

        }
      };
      setFormData(formattedData);
    }).catch((err) => {
      setFormData({
        "role": {
          "roleName": "",
          "roleIcon": ""
        },
        "platforms": {
          "hyperwolf": false,
          "hemp": false,
          "stilo": false,
          "hyperdrive": false
        },
        "permissions": {
          hwPermissions: [], stiloPermissions: [], hempPermissions: [], hyperdrivePermissions: []
        }
      });
    });
  }

  useEffect(() => {
    if (roleId) {
      getRolesData()
    }
  }, [roleId])


  return (
    <CommonLayout>
      {
        getLoding ? <Loader /> :
          <Box p={{ xs: 2, sm: 3, lg: 4 }} className='roles-permissions-con'>
            <Stack direction="row" justifyContent="space-between" flexWrap="wrap" alignItems="stretch" gap={2} mb={2}>
              <span onClick={() => navigate(-1)} className='cur-pointer'>
                <Box display="flex" gap={1} alignItems="center" color='text.main' lineHeight={1}>
                  <AngleRightIcon fontSize="14px" />
                  <Typography variant="h6" fontWeight="semibold" ml={0.75}>
                    Roles and Permissions
                  </Typography>
                </Box>
              </span>
            </Stack>

            <Box p={{ xs: 0 }} className="discrepancy-batch-rep">
              <Card sx={{ p: { xs: 2, md: 3 }, borderRadius: 2.5, boxShadow: 'none' }}>
                <Grid container spacing={3} mb={3}>
                  <Grid item xs={12} md={12} lg={12}>
                    <Typography variant='h4' fontWeight="semibold" color="secondary">{roleId ? "Update" : 'Add'} Role</Typography>
                  </Grid>
                  <Grid item xs={12} md={12} lg={4}>
                    <Typography variant='body2' fontWeight="500" mb={0.5} color="#9A9AAF" style={{ width: "100%" }}>Add Role Name</Typography>
                    <TextField
                      style={{ width: "100%" }}
                      type="text"
                      error={errors?.roleName} helperText={errors.roleName}
                      value={formData?.role?.roleName}
                      onChange={e => {
                        setFormData(prev => ({
                          ...prev,
                          role: {
                            ...prev.role,
                            roleName: e.target.value
                          }
                        }));
                        setErrors({ ...errors, roleName: '' })
                      }
                      }

                    />
                  </Grid>
                  <Grid item xs={12} md={12} lg={4}>
                    <Typography variant='body2' fontWeight="500" mb={0.5} color="#9A9AAF" style={{ width: "100%" }}>Add Icon</Typography>
                    <Stack direction="row" flexWrap="wrap" gap={1.25}>

                      {formData?.role?.roleIcon && <img style={uploadThumbnailImage} src={formData?.role?.roleIcon} alt="documentId" />}

                      <label htmlFor="Id-image">
                        <Box display="flex" sx={{ cursor: 'pointer' }}>
                          {
                            !formData?.role?.roleIcon && isUploading && uploadedFileField.current === 'userIcon' ? <CircularProgress size={32} color='primary' sx={circularProgressIcon} /> :
                              <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
                                <path fillRule="evenodd" clipRule="evenodd" d="M24 2C11.8828 2 2 11.8828 2 24C2 36.1172 11.8828 46 24 46C36.1172 46 46 36.1172 46 24C46 11.8828 36.1172 2 24 2ZM23.9702 12.3929L27.9531 16.3755C28.4791 16.9014 28.4791 17.7542 27.9531 18.2802C27.4272 18.8061 26.5745 18.8061 26.0486 18.2803L25.317 17.5489V26.0541C25.317 26.7981 24.7139 27.4012 23.97 27.4012C23.226 27.4012 22.6229 26.7981 22.6229 26.0541V17.5489L21.8917 18.2801C21.3658 18.806 20.5131 18.806 19.9872 18.2801C19.4613 17.7542 19.4613 16.9015 19.9872 16.3755L23.9702 12.3929ZM34.3346 29.2331C34.3346 30.9589 32.9356 32.3579 31.2098 32.3579H16.7307C15.0049 32.3579 13.6059 30.9589 13.6059 29.2331V27.4552C13.6059 26.7113 14.2089 26.1083 14.9527 26.1083C15.6965 26.1083 16.2996 26.7113 16.2996 27.4552V29.6642H31.6406V27.4553C31.6406 26.7114 32.2436 26.1083 32.9876 26.1083C33.7315 26.1083 34.3346 26.7114 34.3346 27.4553V29.2331Z" fill="#9A9AAF" />
                              </svg>
                          }
                        </Box>
                      </label>

                      <MDInput
                        id="Id-image"
                        type="file"
                        name="ID"
                        onChange={iconImageUploader}
                        fullWidth
                        style={{ display: 'none' }}
                        accept=".png, .jpg, .jpeg"
                      />
                      {
                        errors?.roleIcon && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error={errors?.roleIcon}>{errors?.roleIcon}</FormHelperText>
                      }
                    </Stack>
                  </Grid>

                </Grid>

                <Card sx={{ p: { xs: 2.5 }, mb: 3, borderRadius: 2.5, boxShadow: 'none', backgroundColor: "#F2F3F7" }}>
                  <Typography variant='h5' fontWeight="semibold" color="#2E2E3A" mb={1}>Select Platforms</Typography>
                  <Stack direction="row" alignItems="center" spacing={3} className="checkbox-light">
                    <FormGroup row style={{ gap: "40px" }}>
                      {/* "Select All" Platform Checkbox */}
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={
                              !!formData.platforms?.hyperwolf &&
                              !!formData.platforms?.hemp &&
                              !!formData.platforms?.stilo &&
                              !!formData.platforms?.pos
                            }
                            indeterminate={
                              (
                                !!formData.platforms?.hyperwolf ||
                                !!formData.platforms?.hemp ||
                                !!formData.platforms?.stilo ||
                                !!formData.platforms?.pos
                              ) &&
                              !(
                                !!formData.platforms?.hyperwolf &&
                                !!formData.platforms?.hemp &&
                                !!formData.platforms?.stilo &&
                                !!formData.platforms?.pos
                              )
                            }
                            onChange={e => {
                              const checked = e.target.checked;
                              setFormData(prev => ({
                                ...prev,
                                platforms: {
                                  ...prev.platforms,
                                  hyperwolf: checked,
                                  hemp: checked,
                                  stilo: checked,
                                  pos: checked,
                                }
                              }));
                              setErrors({ ...errors, platforms: '' });
                            }}
                            name="selectAllPlatforms"
                          />
                        }
                        label="Select All"
                      />

                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!formData.platforms?.hyperwolf}
                            onChange={(e) => {
                              setFormData((prev) => ({ ...prev, platforms: { ...prev.platforms, hyperwolf: e.target.checked } }));
                              setErrors({ ...errors, platforms: '' });
                            }}
                            name="hyperwolf"
                          />}
                        label="Hyperwolf"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!formData.platforms?.hemp}
                            onChange={(e) => {
                              setFormData((prev) => ({ ...prev, platforms: { ...prev.platforms, hemp: e.target.checked } }));
                              setErrors({ ...errors, platforms: '' });
                            }}
                            name="hemp"
                          />}
                        label="Hemp"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!formData.platforms?.stilo}
                            onChange={(e) => {
                              setFormData((prev) => ({ ...prev, platforms: { ...prev.platforms, stilo: e.target.checked } }));
                              setErrors({ ...errors, platforms: '' });
                            }}
                            name="stilo"
                          />}
                        label="Stilo"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!formData.platforms?.pos}
                            onChange={(e) => {
                              setFormData((prev) => ({ ...prev, platforms: { ...prev.platforms, pos: e.target.checked } }));
                              setErrors({ ...errors, platforms: '' });
                            }}
                            name="pos"
                          />}
                        label="POS Permissions"
                      />
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={!!formData.platforms?.hyperdrive}
                            onChange={(e) => {
                              setFormData((prev) => ({ ...prev, platforms: { ...prev.platforms, hyperdrive: e.target.checked } }));
                              setErrors({ ...errors, platforms: '' });
                            }}
                            name="pos"
                          />}
                        label="Hyperdrive Permissions"
                      />
                    </FormGroup>

                  </Stack>
                  {
                    errors?.platforms && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error={errors?.platforms}>{errors?.platforms}</FormHelperText>
                  }
                </Card>

                <Box display="flex" alignItems="start" gap={3} minHeight="300px" className="card-box-rep">
                  <Box
                    ref={containerRef}
                    className={`horizontal-scrolling-permission ${isDragging ? 'dragging' : ''}`}
                    onMouseDown={onMouseDown}
                    onMouseLeave={onMouseLeave}
                    onMouseUp={onMouseUp}
                    onMouseMove={onMouseMove}
                    display="flex" alignItems="start" pb={1} overflow="auto" style={{ cursor: isDragging ? "grabbing" : "grab" }}
                  >

                    {/* Hyperwolf Permissions Section */}
                    <Card sx={{
                      minWidth: "320px", marginRight: "32px", borderRadius: 2.5, boxShadow: 'none', background: formData?.platforms?.hyperwolf === false ? "#fff" : "rgba(255, 219, 30, 0.04)", padding: "24px", border: errors?.hwPermissions ? "1px solid #ff381eff" : "1px solid #FFDB1E", opacity: formData?.platforms?.hyperwolf === false ? 0.5 : 1,
                      pointerEvents: formData?.platforms?.hyperwolf === false ? "none" : "auto",
                    }} >
                      {
                        errors?.hwPermissions && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error={errors?.hwPermissions}>{errors?.hwPermissions}</FormHelperText>
                      }
                      <Box display="flex" justifyContent="space-between" alignItems="center" gap={0.5} pb={2.5} mb={2.5} style={{ borderBottom: "1px solid #D0D0DA" }}>
                        <Typography variant="body2" color="#2E2E3A" fontWeight="600">Hyperwolf Permissions</Typography>
                        <FormGroup row className='all-select'>
                          {/* All Select Checkbox - Checks/Unchecks all hyperwolf permissions */}
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  Array.isArray(HwRoutePermission) &&
                                  HwRoutePermission.every(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.every(per =>
                                      !!formData?.permissions?.hwPermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  )
                                }
                                indeterminate={
                                  Array.isArray(HwRoutePermission) &&
                                  HwRoutePermission.some(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.some(per =>
                                      !!formData?.permissions?.hwPermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  ) && !HwRoutePermission.every(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.every(per =>
                                      !!formData?.permissions?.hwPermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  )
                                }
                                onChange={e => {
                                  setErrors({ ...errors, hwPermissions: '' });
                                  const checked = e.target.checked;
                                  setFormData(prev => {
                                    let newPermissions = HwRoutePermission.map(section => ({
                                      title: section.title,
                                      redirectUrl: section?.redirectUrl,
                                      permissions: (section.permissions || []).map(per => ({
                                        title: per.title,
                                        status: checked
                                      }))
                                    }));
                                    return {
                                      ...prev,
                                      permissions: {
                                        ...prev.permissions,
                                        hwPermissions: checked ? newPermissions : HwRoutePermission.map(section => ({
                                          title: section.title,
                                          redirectUrl: section?.redirectUrl,
                                          permissions: (section.permissions || []).map(per => ({
                                            title: per.title,
                                            status: false
                                          }))
                                        }))
                                      }
                                    }
                                  });
                                }}
                              />
                            }
                            label="Select All"
                          />
                        </FormGroup>
                      </Box>
                      {Array.isArray(HwRoutePermission) && HwRoutePermission.map((section, idx) => (
                        <Box key={section.title} mb={2}>
                          <Accordion defaultExpanded>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={`${section.title}-content`}
                              id={`${section.title}-header`}
                            >
                              <Typography variant="body2" color="#2E2E3A" fontWeight="600">{section.title}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <FormGroup className='card-listing'>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        Array.isArray(section.permissions) &&
                                        section.permissions.every(per =>
                                          !!formData?.permissions?.hwPermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        )
                                      }
                                      indeterminate={
                                        Array.isArray(section.permissions) &&
                                        section.permissions.some(per =>
                                          !!formData?.permissions?.hwPermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        ) && !section.permissions.every(per =>
                                          !!formData?.permissions?.hwPermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        )
                                      }
                                      onChange={e => {
                                        setErrors({ ...errors, hwPermissions: '' });
                                        const checked = e.target.checked;
                                        setFormData(prev => {
                                          let hwPermissions = prev.permissions?.hwPermissions || [];
                                          let otherSections = hwPermissions.filter(s => s.title !== section.title);
                                          let newSection = {
                                            title: section.title,
                                            redirectUrl: section?.redirectUrl,
                                            permissions: (section.permissions || []).map(per => ({
                                              title: per.title,
                                              status: checked
                                            }))

                                          };
                                          return {
                                            ...prev,
                                            permissions: {
                                              ...prev.permissions,
                                              hwPermissions: [
                                                ...otherSections,
                                                newSection
                                              ]
                                            }
                                          }
                                        });
                                      }}
                                    />
                                  }
                                  label="Select All"
                                />
                                {/* Individual Permissions */}
                                {Array.isArray(section.permissions) && section.permissions.map(per => (
                                  <FormControlLabel
                                    key={per.title}
                                    control={
                                      <Checkbox
                                        checked={
                                          !!formData?.permissions?.hwPermissions?.find(
                                            (s) => s.title === section.title
                                          )?.permissions?.find(
                                            (p) => p.title === per.title && p.status === true
                                          )
                                        }
                                        onChange={e => {
                                          setErrors({ ...errors, hwPermissions: '' });
                                          const checked = e.target.checked;
                                          setFormData(prev => {
                                            let hwPermissions = prev.permissions?.hwPermissions || [];
                                            // Try to find section
                                            let sectionIndex = hwPermissions.findIndex(s => s.title === section.title);
                                            let updatedSections;
                                            if (sectionIndex !== -1) {
                                              // Section exists, update permission
                                              let sectionObj = { ...hwPermissions[sectionIndex] };
                                              sectionObj.redirectUrl = section?.redirectUrl; // Ensure redirectUrl present
                                              let permIdx = sectionObj.permissions.findIndex(p => p.title === per.title);
                                              if (permIdx !== -1) {
                                                // Update existing
                                                sectionObj.permissions = sectionObj.permissions.map((p, idx) =>
                                                  idx === permIdx ? { ...p, status: checked } : p
                                                );
                                              } else {
                                                // Not found, add new
                                                sectionObj.permissions = [...sectionObj.permissions, { title: per.title, status: checked }];
                                              }
                                              updatedSections = [
                                                ...hwPermissions.slice(0, sectionIndex),
                                                sectionObj,
                                                ...hwPermissions.slice(sectionIndex + 1)
                                              ];
                                            } else {
                                              // Section doesn't exist, add
                                              updatedSections = [
                                                ...hwPermissions,
                                                {
                                                  title: section.title,
                                                  redirectUrl: section?.redirectUrl,
                                                  permissions: [{ title: per.title, status: checked }]
                                                }
                                              ];
                                            }
                                            return {
                                              ...prev,
                                              permissions: {
                                                ...prev.permissions,
                                                hwPermissions: updatedSections
                                              }
                                            }
                                          });
                                        }}
                                      />
                                    }
                                    label={per.title}
                                  />
                                ))}
                              </FormGroup>
                            </AccordionDetails>
                          </Accordion>
                        </Box>
                      ))}
                    </Card>


                    {/* Hemp Permissions Section */}
                    <Card sx={{
                      minWidth: "320px", marginRight: "32px", borderRadius: 2.5, boxShadow: 'none', background: formData?.platforms?.hemp === false ? "#fff" : "rgba(68, 126, 218, 0.04)", padding: "24px", border: errors?.hempPermissions ? "1px solid #ff381eff" : "1px solid #0163FF", opacity: formData?.platforms?.hemp === false ? 0.5 : 1,
                      pointerEvents: formData?.platforms?.hemp === false ? "none" : "auto",
                    }} >
                      {
                        errors?.hempPermissions && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error={errors?.hempPermissions}>{errors?.hempPermissions}</FormHelperText>
                      }
                      <Box display="flex" justifyContent="space-between" alignItems="center" gap={0.5} pb={2.5} mb={2.5} style={{ borderBottom: "1px solid #D0D0DA" }}>
                        <Typography variant="body2" color="#2E2E3A" fontWeight="600">Hemp Permissions</Typography>
                        <FormGroup row className='all-select'>
                          {/* All Select Checkbox - Checks/Unchecks all hemp permissions */}
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  Array.isArray(hempRoutePermission) &&
                                  hempRoutePermission.every(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.every(per =>
                                      !!formData?.permissions?.hempPermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  )
                                }
                                indeterminate={
                                  Array.isArray(hempRoutePermission) &&
                                  hempRoutePermission.some(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.some(per =>
                                      !!formData?.permissions?.hempPermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  ) && !hempRoutePermission.every(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.every(per =>
                                      !!formData?.permissions?.hempPermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  )
                                }
                                onChange={e => {
                                  setErrors({ ...errors, hempPermissions: '' });
                                  const checked = e.target.checked;
                                  setFormData(prev => {
                                    let newPermissions = hempRoutePermission.map(section => ({
                                      title: section.title,
                                      redirectUrl: section?.redirectUrl,
                                      permissions: (section.permissions || []).map(per => ({
                                        title: per.title,
                                        status: checked
                                      }))
                                    }));
                                    return {
                                      ...prev,
                                      permissions: {
                                        ...prev.permissions,
                                        hempPermissions: checked ? newPermissions : hempRoutePermission.map(section => ({
                                          title: section.title,
                                          redirectUrl: section?.redirectUrl,
                                          permissions: (section.permissions || []).map(per => ({
                                            title: per.title,
                                            status: false
                                          }))
                                        }))
                                      }
                                    }
                                  });
                                }}
                              />
                            }
                            label="Select All"
                          />
                        </FormGroup>
                      </Box>
                      {Array.isArray(hempRoutePermission) && hempRoutePermission.map((section, idx) => (
                        <Box key={section.title} mb={2}>
                          <Accordion defaultExpanded>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={`${section.title}-content`}
                              id={`${section.title}-header`}
                            >
                              <Typography variant="body2" color="#2E2E3A" fontWeight="600">{section.title}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <FormGroup className='card-listing'>
                                {/* Section "Select All" Checkbox */}
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        Array.isArray(section.permissions) &&
                                        section.permissions.every(per =>
                                          !!formData?.permissions?.hempPermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        )
                                      }
                                      indeterminate={
                                        Array.isArray(section.permissions) &&
                                        section.permissions.some(per =>
                                          !!formData?.permissions?.hempPermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        ) && !section.permissions.every(per =>
                                          !!formData?.permissions?.hempPermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        )
                                      }
                                      onChange={e => {
                                        setErrors({ ...errors, hempPermissions: '' });
                                        const checked = e.target.checked;
                                        setFormData(prev => {
                                          let hempPermissions = prev.permissions?.hempPermissions || [];
                                          let otherSections = hempPermissions.filter(s => s.title !== section.title);
                                          let newSection = {
                                            title: section.title,
                                            redirectUrl: section?.redirectUrl,
                                            permissions: (section.permissions || []).map(per => ({
                                              title: per.title,
                                              status: checked
                                            }))
                                          };
                                          return {
                                            ...prev,
                                            permissions: {
                                              ...prev.permissions,
                                              hempPermissions: [
                                                ...otherSections,
                                                newSection
                                              ]
                                            }
                                          }
                                        });
                                      }}
                                    />
                                  }
                                  label="Select All"
                                />
                                {/* Individual Permissions */}
                                {Array.isArray(section.permissions) && section.permissions.map(per => (
                                  <FormControlLabel
                                    key={per.title}
                                    control={
                                      <Checkbox
                                        checked={
                                          !!formData?.permissions?.hempPermissions?.find(
                                            (s) => s.title === section.title
                                          )?.permissions?.find(
                                            (p) => p.title === per.title && p.status === true
                                          )
                                        }
                                        onChange={e => {
                                          setErrors({ ...errors, hempPermissions: '' });
                                          const checked = e.target.checked;
                                          setFormData(prev => {
                                            let hempPermissions = prev.permissions?.hempPermissions || [];
                                            // Try to find section
                                            let sectionIndex = hempPermissions.findIndex(s => s.title === section.title);
                                            let updatedSections;
                                            if (sectionIndex !== -1) {
                                              // Section exists, update permission
                                              let sectionObj = { ...hempPermissions[sectionIndex] };
                                              sectionObj.redirectUrl = section?.redirectUrl; // Ensure redirectUrl present

                                              let permIdx = sectionObj.permissions.findIndex(p => p.title === per.title);
                                              if (permIdx !== -1) {
                                                // Update existing
                                                sectionObj.permissions = sectionObj.permissions.map((p, idx) =>
                                                  idx === permIdx ? { ...p, status: checked } : p
                                                );
                                              } else {
                                                // Not found, add new
                                                sectionObj.permissions = [...sectionObj.permissions, { title: per.title, status: checked }];
                                              }
                                              updatedSections = [
                                                ...hempPermissions.slice(0, sectionIndex),
                                                sectionObj,
                                                ...hempPermissions.slice(sectionIndex + 1)
                                              ];
                                            } else {
                                              // Section doesn't exist, add
                                              updatedSections = [
                                                ...hempPermissions,
                                                {
                                                  title: section.title,
                                                  redirectUrl: section?.redirectUrl,
                                                  permissions: [{ title: per.title, status: checked }]
                                                }
                                              ];
                                            }
                                            return {
                                              ...prev,
                                              permissions: {
                                                ...prev.permissions,
                                                hempPermissions: updatedSections
                                              }
                                            }
                                          });
                                        }}
                                      />
                                    }
                                    label={per.title}
                                  />
                                ))}
                              </FormGroup>
                            </AccordionDetails>
                          </Accordion>
                        </Box>
                      ))}
                    </Card>

                    {/* Stilo Permissions Section */}
                    <Card sx={{
                      minWidth: "320px", marginRight: "32px", borderRadius: 2.5, boxShadow: 'none', background: formData?.platforms?.stilo === false ? "#fff" : "rgba(4, 195, 221, 0.04)", padding: "24px", border: errors?.stiloPermissions ? "1px solid #ff381eff" : "1px solid #04C3DD", opacity: formData?.platforms?.stilo === false ? 0.5 : 1,
                      pointerEvents: formData?.platforms?.stilo === false ? "none" : "auto",
                    }}>
                      {
                        errors?.stiloPermissions && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error={errors?.stiloPermissions}>{errors?.stiloPermissions}</FormHelperText>
                      }
                      <Box display="flex" justifyContent="space-between" alignItems="center" gap={0.5} pb={2.5} mb={2.5} style={{ borderBottom: "1px solid #D0D0DA" }}>
                        <Typography variant="body2" color="#2E2E3A" fontWeight="600">Stilo Permissions</Typography>
                        <FormGroup row className='all-select'>
                          {/* All Select Checkbox - Checks/Unchecks all hemp permissions */}
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  Array.isArray(stiloRoutePermission) &&
                                  stiloRoutePermission.every(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.every(per =>
                                      !!formData?.permissions?.stiloPermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  )
                                }
                                indeterminate={
                                  Array.isArray(stiloRoutePermission) &&
                                  stiloRoutePermission.some(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.some(per =>
                                      !!formData?.permissions?.stiloPermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  ) && !stiloRoutePermission.every(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.every(per =>
                                      !!formData?.permissions?.stiloPermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  )
                                }
                                onChange={e => {
                                  setErrors({ ...errors, stiloPermissions: '' });

                                  const checked = e.target.checked;
                                  setFormData(prev => {
                                    let newPermissions = stiloRoutePermission.map(section => ({
                                      title: section.title,
                                      redirectUrl: section?.redirectUrl,
                                      permissions: (section.permissions || []).map(per => ({
                                        title: per.title,
                                        status: checked
                                      }))
                                    }));
                                    return {
                                      ...prev,
                                      permissions: {
                                        ...prev.permissions,
                                        stiloPermissions: checked ? newPermissions : stiloRoutePermission.map(section => ({
                                          title: section.title,
                                          redirectUrl: section?.redirectUrl,
                                          permissions: (section.permissions || []).map(per => ({
                                            title: per.title,
                                            status: false
                                          }))
                                        }))
                                      }
                                    }
                                  });
                                }}
                              />
                            }
                            label="Select All"
                          />
                        </FormGroup>
                      </Box>
                      {Array.isArray(stiloRoutePermission) && stiloRoutePermission.map((section, idx) => (
                        <Box key={section.title} mb={2}>
                          <Accordion defaultExpanded>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={`${section.title}-content`}
                              id={`${section.title}-header`}
                            >
                              <Typography variant="body2" color="#2E2E3A" fontWeight="600">{section.title}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <FormGroup className='card-listing'>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        Array.isArray(section.permissions) &&
                                        section.permissions.every(per =>
                                          !!formData?.permissions?.stiloPermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        )
                                      }
                                      indeterminate={
                                        Array.isArray(section.permissions) &&
                                        section.permissions.some(per =>
                                          !!formData?.permissions?.stiloPermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        ) && !section.permissions.every(per =>
                                          !!formData?.permissions?.stiloPermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        )
                                      }
                                      onChange={e => {
                                        setErrors({ ...errors, stiloPermissions: '' });
                                        const checked = e.target.checked;
                                        setFormData(prev => {
                                          let stiloPermissions = prev.permissions?.stiloPermissions || [];
                                          let otherSections = stiloPermissions.filter(s => s.title !== section.title);
                                          let newSection = {
                                            title: section.title,
                                            redirectUrl: section?.redirectUrl,
                                            permissions: (section.permissions || []).map(per => ({
                                              title: per.title,
                                              status: checked
                                            }))
                                          };
                                          return {
                                            ...prev,
                                            permissions: {
                                              ...prev.permissions,
                                              stiloPermissions: [
                                                ...otherSections,
                                                newSection
                                              ]
                                            }
                                          }
                                        });
                                      }}
                                    />
                                  }
                                  label="Select All"
                                />

                                {/* Individual Permissions */}
                                {Array.isArray(section.permissions) && section.permissions.map(per => (
                                  <FormControlLabel
                                    key={per.title}
                                    control={
                                      <Checkbox
                                        checked={
                                          !!formData?.permissions?.stiloPermissions?.find(
                                            (s) => s.title === section.title
                                          )?.permissions?.find(
                                            (p) => p.title === per.title && p.status === true
                                          )
                                        }
                                        onChange={e => {
                                          setErrors({ ...errors, stiloPermissions: '' });
                                          const checked = e.target.checked;
                                          setFormData(prev => {
                                            let stiloPermissions = prev.permissions?.stiloPermissions || [];
                                            // Try to find section
                                            let sectionIndex = stiloPermissions.findIndex(s => s.title === section.title);
                                            let updatedSections;
                                            if (sectionIndex !== -1) {
                                              // Section exists, update permission
                                              let sectionObj = { ...stiloPermissions[sectionIndex] };
                                              sectionObj.redirectUrl = section?.redirectUrl;
                                              let permIdx = sectionObj.permissions.findIndex(p => p.title === per.title);
                                              if (permIdx !== -1) {
                                                // Update existing
                                                sectionObj.permissions = sectionObj.permissions.map((p, idx) =>
                                                  idx === permIdx ? { ...p, status: checked } : p
                                                );
                                              } else {
                                                // Not found, add new
                                                sectionObj.permissions = [...sectionObj.permissions, { title: per.title, status: checked }];
                                              }
                                              updatedSections = [
                                                ...stiloPermissions.slice(0, sectionIndex),
                                                sectionObj,
                                                ...stiloPermissions.slice(sectionIndex + 1)
                                              ];
                                            } else {
                                              // Section doesn't exist, add
                                              updatedSections = [
                                                ...stiloPermissions,
                                                {
                                                  redirectUrl: section?.redirectUrl,
                                                  title: section.title,
                                                  permissions: [{ title: per.title, status: checked }]
                                                }
                                              ];
                                            }
                                            return {
                                              ...prev,
                                              permissions: {
                                                ...prev.permissions,
                                                stiloPermissions: updatedSections
                                              }
                                            }
                                          });
                                        }}
                                      />
                                    }
                                    label={per.title}
                                  />
                                ))}
                              </FormGroup>
                            </AccordionDetails>
                          </Accordion>
                        </Box>
                      ))}
                    </Card>

                    {/* POS Permissions Section */}
                    <Card sx={{
                      minWidth: "320px", marginRight: "32px",borderRadius: 2.5, boxShadow: 'none', background: formData?.platforms?.pos === false ? "#fff" : "rgba(46, 46, 58, 0.04)", padding: "24px", border: errors?.posPermissions ? "1px solid #ff381eff" : "1px solid #2E2E3A", opacity: formData?.platforms?.pos === false ? 0.5 : 1,
                      pointerEvents: formData?.platforms?.pos === false ? "none" : "auto",
                    }}>
                      {
                        errors?.posPermissions && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error={errors?.posPermissions}>{errors?.posPermissions}</FormHelperText>
                      }
                      <Box display="flex" justifyContent="space-between" alignItems="center" gap={0.5} pb={2.5} mb={2.5} style={{ borderBottom: "1px solid #D0D0DA" }}>
                        <Typography variant="body2" color="#2E2E3A" fontWeight="600">POS Permissions</Typography>
                        <FormGroup row className='all-select'>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  Array.isArray(posRoutePermission) &&
                                  posRoutePermission.every(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.every(per =>
                                      !!formData?.permissions?.posPermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  )
                                }
                                indeterminate={
                                  Array.isArray(posRoutePermission) &&
                                  posRoutePermission.some(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.some(per =>
                                      !!formData?.permissions?.posPermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  ) && !posRoutePermission.every(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.every(per =>
                                      !!formData?.permissions?.posPermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  )
                                }
                                onChange={e => {
                                  setErrors({ ...errors, posPermissions: '' });

                                  const checked = e.target.checked;
                                  setFormData(prev => {
                                    let newPermissions = posRoutePermission.map(section => ({
                                      title: section?.title,
                                      redirectUrl: section?.redirectUrl,
                                      permissions: (section.permissions || []).map(per => ({
                                        title: per.title,
                                        status: checked
                                      }))
                                    }));
                                    return {
                                      ...prev,
                                      permissions: {
                                        ...prev.permissions,
                                        posPermissions: checked ? newPermissions : posRoutePermission.map(section => ({
                                          title: section.title,
                                          redirectUrl: section?.redirectUrl,
                                          permissions: (section.permissions || []).map(per => ({
                                            title: per.title,
                                            status: false
                                          }))
                                        }))
                                      }
                                    }
                                  });
                                }}
                              />
                            }
                            label="Select All"
                          />
                        </FormGroup>
                      </Box>
                      {Array.isArray(posRoutePermission) && posRoutePermission.map((section, idx) => (
                        <Box key={section.title} mb={2}>
                          <Accordion defaultExpanded>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={`${section.title}-content`}
                              id={`${section.title}-header`}
                            >
                              <Typography variant="body2" color="#2E2E3A" fontWeight="600">{section.title}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <FormGroup className='card-listing'>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        Array.isArray(section.permissions) &&
                                        section.permissions.every(per =>
                                          !!formData?.permissions?.posPermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        )
                                      }
                                      indeterminate={
                                        Array.isArray(section.permissions) &&
                                        section.permissions.some(per =>
                                          !!formData?.permissions?.posPermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        ) && !section.permissions.every(per =>
                                          !!formData?.permissions?.posPermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        )
                                      }
                                      onChange={e => {
                                        setErrors({ ...errors, posPermissions: '' });

                                        const checked = e.target.checked;
                                        setFormData(prev => {
                                          let posPermissions = prev.permissions?.posPermissions || [];
                                          let otherSections = posPermissions.filter(s => s.title !== section.title);
                                          let newSection = {
                                            title: section.title,
                                            redirectUrl: section?.redirectUrl,
                                            permissions: (section.permissions || []).map(per => ({
                                              title: per.title,
                                              status: checked
                                            }))
                                          };
                                          return {
                                            ...prev,
                                            permissions: {
                                              ...prev.permissions,
                                              posPermissions: [
                                                ...otherSections,
                                                newSection
                                              ]
                                            }
                                          }
                                        });
                                      }}
                                    />
                                  }
                                  label="Select All"
                                />
                                {Array.isArray(section.permissions) && section.permissions.map(per => (
                                  <FormControlLabel
                                    key={per.title}
                                    control={
                                      <Checkbox
                                        checked={
                                          !!formData?.permissions?.posPermissions?.find(
                                            (s) => s.title === section.title
                                          )?.permissions?.find(
                                            (p) => p.title === per.title && p.status === true
                                          )
                                        }
                                        onChange={e => {
                                          setErrors({ ...errors, posPermissions: '' });

                                          const checked = e.target.checked;
                                          setFormData(prev => {
                                            let posPermissions = prev.permissions?.posPermissions || [];
                                            let sectionIndex = posPermissions.findIndex(s => s.title === section.title);
                                            let updatedSections;
                                            if (sectionIndex !== -1) {
                                              let sectionObj = { ...posPermissions[sectionIndex] };
                                              sectionObj.redirectUrl = section?.redirectUrl;
                                              let permIdx = sectionObj.permissions.findIndex(p => p.title === per.title);
                                              if (permIdx !== -1) {
                                                sectionObj.permissions = sectionObj.permissions.map((p, idx) =>
                                                  idx === permIdx ? { ...p, status: checked } : p
                                                );
                                              } else {
                                                sectionObj.permissions = [...sectionObj.permissions, { title: per.title, status: checked }];
                                              }
                                              updatedSections = [
                                                ...posPermissions.slice(0, sectionIndex),
                                                sectionObj,
                                                ...posPermissions.slice(sectionIndex + 1)
                                              ];
                                            } else {
                                              updatedSections = [
                                                ...posPermissions,
                                                {
                                                  title: section.title,
                                                  redirectUrl: section?.redirectUrl,
                                                  permissions: [{ title: per.title, status: checked }]
                                                }
                                              ];
                                            }
                                            return {
                                              ...prev,
                                              permissions: {
                                                ...prev.permissions,
                                                posPermissions: updatedSections
                                              }
                                            }
                                          });
                                        }}
                                      />
                                    }
                                    label={per.title}
                                  />
                                ))}
                              </FormGroup>
                            </AccordionDetails>
                          </Accordion>
                        </Box>
                      ))}
                    </Card>

                    {/* hyperdrive */}
                    <Card sx={{
                      minWidth: "320px", borderRadius: 2.5, boxShadow: 'none', background: formData?.platforms?.hyperdrive === false ? "#fff" : "rgba(46, 46, 58, 0.04)", padding: "24px", border: errors?.hyperdrivePermissions ? "1px solid #ff381eff" : "1px solid #2E2E3A", opacity: formData?.platforms?.hyperdrive === false ? 0.5 : 1,
                      pointerEvents: formData?.platforms?.hyperdrive === false ? "none" : "auto",
                    }}>
                      {
                        errors?.hyperdrivePermissions && <FormHelperText sx={{ width: '100%', ml: 0, mt: -.5 }} error={errors?.hyperdrivePermissions}>{errors?.hyperdrivePermissions}</FormHelperText>
                      }
                      <Box display="flex" justifyContent="space-between" alignItems="center" gap={0.5} pb={2.5} mb={2.5} style={{ borderBottom: "1px solid #D0D0DA" }}>
                        <Typography variant="body2" color="#2E2E3A" fontWeight="600">Hyperdrive Permissions</Typography>
                        <FormGroup row className='all-select'>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={
                                  Array.isArray(HperdriveRoutePermission) &&
                                  HperdriveRoutePermission.every(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.every(per =>
                                      !!formData?.permissions?.hyperdrivePermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  )
                                }
                                indeterminate={
                                  Array.isArray(HperdriveRoutePermission) &&
                                  HperdriveRoutePermission.some(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.some(per =>
                                      !!formData?.permissions?.hyperdrivePermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  ) && !HperdriveRoutePermission.every(section =>
                                    Array.isArray(section.permissions) &&
                                    section.permissions.every(per =>
                                      !!formData?.permissions?.hyperdrivePermissions?.find(
                                        (s) => s.title === section.title
                                      )?.permissions?.find(
                                        (p) => p.title === per.title && p.status === true
                                      )
                                    )
                                  )
                                }
                                onChange={e => {
                                  setErrors({ ...errors, hyperdrivePermissions: '' });

                                  const checked = e.target.checked;
                                  setFormData(prev => {
                                    let newPermissions = HperdriveRoutePermission.map(section => ({
                                      title: section?.title,
                                      redirectUrl: section?.redirectUrl,
                                      permissions: (section.permissions || []).map(per => ({
                                        title: per.title,
                                        status: checked
                                      }))
                                    }));
                                    return {
                                      ...prev,
                                      permissions: {
                                        ...prev.permissions,
                                        hyperdrivePermissions: checked ? newPermissions : HperdriveRoutePermission.map(section => ({
                                          title: section.title,
                                          redirectUrl: section?.redirectUrl,
                                          permissions: (section.permissions || []).map(per => ({
                                            title: per.title,
                                            status: false
                                          }))
                                        }))
                                      }
                                    }
                                  });
                                }}
                              />
                            }
                            label="Select All"
                          />
                        </FormGroup>
                      </Box>
                      {Array.isArray(HperdriveRoutePermission) && HperdriveRoutePermission.map((section, idx) => (
                        <Box key={section.title} mb={2}>
                          <Accordion defaultExpanded>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={`${section.title}-content`}
                              id={`${section.title}-header`}
                            >
                              <Typography variant="body2" color="#2E2E3A" fontWeight="600">{section.title}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                              <FormGroup className='card-listing'>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={
                                        Array.isArray(section.permissions) &&
                                        section.permissions.every(per =>
                                          !!formData?.permissions?.hyperdrivePermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        )
                                      }
                                      indeterminate={
                                        Array.isArray(section.permissions) &&
                                        section.permissions.some(per =>
                                          !!formData?.permissions?.hyperdrivePermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        ) && !section.permissions.every(per =>
                                          !!formData?.permissions?.hyperdrivePermissions?.find(
                                            s => s.title === section.title
                                          )?.permissions?.find(
                                            p => p.title === per.title && p.status === true
                                          )
                                        )
                                      }
                                      onChange={e => {
                                        setErrors({ ...errors, hyperdrivePermissions: '' });

                                        const checked = e.target.checked;
                                        setFormData(prev => {
                                          let hyperdrivePermissions = prev.permissions?.hyperdrivePermissions || [];
                                          let otherSections = hyperdrivePermissions.filter(s => s.title !== section.title);
                                          let newSection = {
                                            title: section.title,
                                            redirectUrl: section?.redirectUrl,
                                            permissions: (section.permissions || []).map(per => ({
                                              title: per.title,
                                              status: checked
                                            }))
                                          };
                                          return {
                                            ...prev,
                                            permissions: {
                                              ...prev.permissions,
                                              hyperdrivePermissions: [
                                                ...otherSections,
                                                newSection
                                              ]
                                            }
                                          }
                                        });
                                      }}
                                    />
                                  }
                                  label="Select All"
                                />
                                {Array.isArray(section.permissions) && section.permissions.map(per => (
                                  <FormControlLabel
                                    key={per.title}
                                    control={
                                      <Checkbox
                                        checked={
                                          !!formData?.permissions?.hyperdrivePermissions?.find(
                                            (s) => s.title === section.title
                                          )?.permissions?.find(
                                            (p) => p.title === per.title && p.status === true
                                          )
                                        }
                                        onChange={e => {
                                          setErrors({ ...errors, hyperdrivePermissions: '' });

                                          const checked = e.target.checked;
                                          setFormData(prev => {
                                            let hyperdrivePermissions = prev.permissions?.hyperdrivePermissions || [];
                                            let sectionIndex = hyperdrivePermissions.findIndex(s => s.title === section.title);
                                            let updatedSections;
                                            if (sectionIndex !== -1) {
                                              let sectionObj = { ...hyperdrivePermissions[sectionIndex] };
                                              sectionObj.redirectUrl = section?.redirectUrl;
                                              let permIdx = sectionObj.permissions.findIndex(p => p.title === per.title);
                                              if (permIdx !== -1) {
                                                sectionObj.permissions = sectionObj.permissions.map((p, idx) =>
                                                  idx === permIdx ? { ...p, status: checked } : p
                                                );
                                              } else {
                                                sectionObj.permissions = [...sectionObj.permissions, { title: per.title, status: checked }];
                                              }
                                              updatedSections = [
                                                ...hyperdrivePermissions.slice(0, sectionIndex),
                                                sectionObj,
                                                ...hyperdrivePermissions.slice(sectionIndex + 1)
                                              ];
                                            } else {
                                              updatedSections = [
                                                ...hyperdrivePermissions,
                                                {
                                                  title: section.title,
                                                  redirectUrl: section?.redirectUrl,
                                                  permissions: [{ title: per.title, status: checked }]
                                                }
                                              ];
                                            }
                                            return {
                                              ...prev,
                                              permissions: {
                                                ...prev.permissions,
                                                hyperdrivePermissions: updatedSections
                                              }
                                            }
                                          });
                                        }}
                                      />
                                    }
                                    label={per.title}
                                  />
                                ))}
                              </FormGroup>
                            </AccordionDetails>
                          </Accordion>
                        </Box>
                      ))}
                    </Card>

                  </Box>
                </Box>
              </Card>

              <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1.25} mt={4} mb={2}>
                <MDButton
                  sx={{ minWidth: '160px' }}
                  type='button'
                  variant='contained'
                  color='primary'
                  onClick={handleSubmit}
                  disabled={isUploading || loading}
                  loading={isUploading || loading}
                >
                  {roleId ? "Update" : "Save"}
                </MDButton>
                <MDButton
                  sx={{ minWidth: '160px' }}
                  type='button'
                  variant='outlined'
                  color='dark'
                  onClick={() => navigate(-1)}
                >
                  Cancel
                </MDButton>
              </Stack>
            </Box>
          </Box>
      }
    </CommonLayout>
  );
}

